<template>
  <div class="empty_wrap">
    <div>
      <img src="@/assets/img/activity/emptyData@2x.png" alt="" />
      <p>{{ text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "EmptyData",
  props: {
    text: {
      type: String,
      default: "暂无岗位推荐啦",
    },
  },
};
</script>
<style scoped lang="less">
.empty_wrap {
  width: 100%;
  & > div {
    margin: 0 8px;
    margin-top: 4px;
    height: 181px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .adapt_pc_widescreen & {
        margin: 0 16px;
        height: 220px;
      }
    & > p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #40454f;
      line-height: 17px;
      margin-top: 11px;
      .adapt_pc_widescreen & {
        font-size: 14px;
      }
    }
    & > img {
      width: 89px;
      height: auto;
      .adapt_pc_widescreen & {
        width: 178px;
        height: 140px;
      }
    }
  }
}
</style>
